import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import { useDispatch } from "react-redux";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import CarePackagesTest from "./TemplateForms/TestPackages";
import AssignPatient from "./TemplateForms/AssignPatient";
import {
  useGetAssignmentHistoryQuery,
  useGetCarePackagesQuery,
} from "../../../Service/CarePackages";
import Loader from "../../../Component/DigitalMarketing/Loader";

const CarePackages = () => {
  const [show, setShow] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [updateData, setUpdateData] = useState(null);
  const [tabName, setTabName] = useState("");
  const [pagination, setPagination] = useState(1);
  const dispatch = useDispatch();

  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const { data: carepackageData, refetch,isLoading } = useGetCarePackagesQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const { data: assignmenthistoryData, refetch: refetchhistory } =
    useGetAssignmentHistoryQuery(pagi, {
      refetchOnMountOrArgChange: true,
    });

    const onChangeSearch = (event) => {
      setSearchValue(event.target.value);
    };

  useEffect(() => {
    const data:any = {
      first: "Care Packages"
    };
    dispatch(Change(data));
  }, [show, updateData, tabName, dispatch]);

  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <div>
        <DashTabs
          setShow={setShow}
          show={show}
          setActiveIndex={setActiveIndex}
          setUpdateData={setUpdateData}
          setTabName={setTabName}
        />
      </div>

      <Row className="mb-3">
        <Col md={5}>
          <SearchBox 
           value={searchValue}
           onChange={(event) => onChangeSearch(event)} />
        </Col>
      </Row>

      <div className="row">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            setShow={setShow}
            carepackageData={carepackageData}
            assignmenthistoryData={assignmenthistoryData}
            refetch={refetch}
            activeIndex={activeIndex}
            setUpdateData={setUpdateData}
          />
        </div>

        {show && (
          <div
            className="col-4"
            style={{ backgroundColor: "white", height: "70vh" }}
          >
            {activeIndex === 1 && (
              <CarePackagesTest
                refetch={refetch}
                updateData={updateData}
                setShow={setShow}
              />
            )}
            {activeIndex === 2 && (
              <AssignPatient updateData={updateData} setShow={setShow} />
            )}
          </div>
        )}
        <Pagination
          setpagination={setPagination}
          pagination={pagination}
          data={activeIndex === 1 ? carepackageData : null}
        />
      </div>
    </div>
  );
};

export default CarePackages;
